import React from "react";
import TabCardGrid from "pham-sushi/components/TabCardGrid.js";
import { menuTakeaway } from "pham-sushi/data/menu_takeaway";

export default () => {
    return (
        <>
            {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
            <TabCardGrid
                heading={
                    <>
                        Takeaway Menu
                    </>
                } 
                subHeading={
                    <>
                        To order Please call us at 0207-638-6668 <br />
                        <strong> 5% off on all collection </strong>
                    </>
                } 
                tabs={menuTakeaway}
                showPrice={true}
            />
        </>
    );
}
